export const INBOX_TYPES = {
  EMAIL: 'email',
  WEB: 'web',
  SMS: 'sms',
  SUPPORT_FORM: 'support_form',
  SUPPORT_WIDGET: 'support_widget',
  INTERNAL_TICKET: 'internal_ticket',
  HELPDESK: 'helpdesk',
}

export const KB_ARTICLES_STATUS_TYPES = {
  ALL_ARTICLE: 'All',
  PUBLISHED: 'publish',
  TRASH: 'Trash',
  DRAFT: 'Draft',
}

export const KB_ARTICLES_SORT_TYPES = {
  SORT_BY: 'Sort',
  DATE_MODIFIED: 'dateModify',
  TITLE_A_Z: 'titleAZ',
  TITLE_Z_A: 'titleZA',
  HIGHEST_RATINGS: 'ratingHigh',
  LOWEST_RATINGS: 'ratingLow',
}

export const KB_ARTICLES_ORDER_BY = {
  TITLE_A_Z: 'titleAZ',
  TITLE_Z_A: 'titleZA',
  CREATED_AT_ASC: 'createdAtASC',
  CREATED_AT_DESC: 'createdAtDESC',
  UPDATED_AT_ASC: 'dateModifyASC',
  UPDATED_AT_DESC: 'dateModifyDESC',
}

export const KB_CATEGORIES_ORDER_BY = {
  TITLE_A_Z: 'titleAZ',
  TITLE_Z_A: 'titleZA',
  CREATED_AT_ASC: 'createdAtASC',
  CREATED_AT_DESC: 'createdAtDESC',
  UPDATED_AT_ASC: 'dateModifyASC',
  UPDATED_AT_DESC: 'dateModifyDESC',
}
